import React from "react";
import styles from "./ProductDescription.module.scss";
import classnames from "classnames";

interface ProductDescriptionProps {
  className?: string;
  description: string;
  maxWidth?: string;
  maxLines?: number;
  "data-testid"?: string;
}

export default function ProductDescription({
  className,
  description,
  maxWidth,
  maxLines,
  "data-testid": dataTestId = "product-description",
}: ProductDescriptionProps) {
  const isCondensed = !!maxWidth || !!maxLines;
  const maxWidthStyles = !!maxWidth ? { maxWidth } : {};
  const maxLinesStyles = !!maxLines ? { WebkitLineClamp: maxLines } : {};

  return (
    <span
      className={classnames(className, styles.root, {
        [styles.condensed]: isCondensed,
        [styles.clamped]: !!maxLines,
      })}
      style={{ ...maxWidthStyles, ...maxLinesStyles }}
      dangerouslySetInnerHTML={{ __html: description }}
      data-testid={dataTestId}
    />
  );
}
